export const NAME = 'iban';

export const REQUEST_GET_IBAN = 'REQUEST_GET_IBAN';
export const SUCCESS_GET_IBAN = 'SUCCESS_GET_IBAN';
export const FAILURE_GET_IBAN = 'FAILURE_GET_IBAN';

export const REQUEST_CREATE_IBAN = 'REQUEST_CREATE_IBAN';
export const SUCCESS_CREATE_IBAN = 'SUCCESS_CREATE_IBAN';
export const FAILURE_CREATE_IBAN = 'FAILURE_CREATE_IBAN';

export const REQUEST_DELETE_IBAN = 'REQUEST_DELETE_IBAN';
export const SUCCESS_DELETE_IBAN = 'SUCCESS_DELETE_IBAN';
export const FAILURE_DELETE_IBAN = 'FAILURE_DELETE_IBAN';

export const RESET_FORM_SUBMIT_UPDATE_IBAN = 'RESET_FORM_SUBMIT_UPDATE_IBAN';

export const IBAN_TYPE_PERSONNAL = 1;
export const IBAN_TYPE_RELATIVE = 2;

export const SET_TIMEOUT_ID = 'SET_TIMEOUT_ID';
export const CLEAR_TIMEOUT_ID = 'CLEAR_TIMEOUT_ID';



// WEBPACK FOOTER //
// ./src/services/account/iban/constants.js